import { useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { Box, Grid2 as Grid, Typography } from "@mui/material";
import FamilyDetailsData from "./data.json";
import NotFound from "../../../../components/NotFound/not-found";
//import IconTablaNutrimental from '../../../../assets/images/icon-tabla_nutrimental.png';
import IconIngredientes from '../../../../assets/images/icon-ingredientes.png';
import Loader from "../../../../components/Loader/loader";
import ProductModal from '../../../../components/ProductModal/product-modal';

import './family-details.css';
const imagesPath = "/assets"

export default function FamilyDetails() {
  const navigate = useNavigate();
  const [data, setData] = useState(null);
  const [isLoading, setIsLoading] = useState(true);
  const [isModalOpen, setModalOpen] = useState(false);
  const [modalContent, setModalContent] = useState({ type: '', content: '' });

  const { topic } = useParams();
  const icons = [
    //{ src: IconTablaNutrimental, text: "Tabla nutrimental", type: "nutritional" },
    { src: IconIngredientes, text: "Ingredientes", type: "ingredients" }
  ];

  const openModal = (type, content) => {
    const contentData = type === 'nutritional' ? content.nutritionalTable : content.ingredients;
    setModalContent({ type, content: contentData });
    setModalOpen(true);
  };

  const closeModal = () => setModalOpen(false);

  useEffect(() => {
    const getDetails = async () => {
      const topicData = FamilyDetailsData.find(item => item.topic === topic);
      if (topicData) {
        setData(topicData);
      } else {
        setData(null);
      }
      setIsLoading(false);
    }
    getDetails();
  }, [topic]);

  if (isLoading) {
    return <Loader />
  }
  if (!data) {
    return <NotFound />;
  }

  const handleClick = ({ path }) => {
    if (path) {
      navigate(path);
    }
  };

  return (
    <Box className="family-section">
      <Grid container spacing={5} className="family-section__details" >
        <Grid item size={{ xs: 12, sm: 6, md: 6, lg: 6 }} className="family-details__image">
          <Box
            component="img"
            src={`${imagesPath}/products/${data.productImage}`}
            className="family-details__image family-details__image--large"
            alt={data.topic}
          />
        </Grid>
        <Grid item size={{ xs: 12, sm: 5, md: 5, lg: 5 }} className="family-details__description">
          <Box
            component="img"
            src={`${imagesPath}/products/${data.productLogo}`}
            className={`family-details__image-logo family-details__image-logo--${data.topic}`}
            alt={data.topic}
          />
          <Box className="family-details__description-icons">
            {icons.map((icon, idx) => (
              <Box key={idx} className="family-details__image-icon-container" onClick={() => openModal(icon.type, data)}>
                <Box
                  component="img"
                  src={icon.src}
                  className="family-details__image-icon"
                  alt={icon.text}
                />
                <Typography variant="caption" className="family-details__image-icon-text">
                  {icon.text}
                </Typography>
              </Box>
            ))}
          </Box>
          <Box className="family-details__description-text">
            <Typography variant="body1" className="family-details__description-text--presentation">
              {data.presentation}
            </Typography>
            <Typography variant="body1" className="family-details__description-text--description" dangerouslySetInnerHTML={{ __html: data.description }} />
          </Box>
        </Grid>
      </Grid>
      <Box className="family-details__footer">
        {data.products && data.products.length > 0 && (
          <Box className="family-details__footer-products">
            <Typography variant="h4" className="family-details__footer-title">
              ✧ Presentaciones ✧
            </Typography>
            <Box className="family-details__footer-products-list">
              {data.products.map((product, index) => (
                <Box key={index} className="family-details__footer-product">
                  <Box
                    component="img"
                    src={`${imagesPath}/products/${product.image}`}
                    alt={product.name}
                    className="family-details__footer-product-image"
                    onClick={() => handleClick({ path: product.link })}
                  />
                </Box>
              ))}
            </Box>
          </Box>
        )}
      </Box>
      <ProductModal
        open={isModalOpen}
        handleClose={closeModal}
        type={modalContent.type}
        content={modalContent.content}
      />
    </Box>
  );
}